import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const getAllCurrencies = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_CURRENCIES
    },
    method: handlers.GET_ALL_CURRENCIES,
    tabId: 0
});

export const setActive = (code) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SET_CURRENCY,
        params: {
            code: code
        }
    },
    method: handlers.SET_CURRENCY,
    tabId: 0
});

export const addCurrency = (name, code, symbol, rate, rounding) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_CURRENCY,
        params: {
            name: name,
            code: code,
            symbol: symbol,
            rate: rate,
            rounding: rounding,
            visible: true
        }
    },
    method: handlers.ADD_CURRENCY,
    tabId: 0
});

export const editCurrency = (id, name, code, symbol, rate, rounding, visible) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EDIT_CURRENCY,
        params: {
            id: id,
            name: name,
            code: code,
            symbol: symbol,
            rate: rate,
            rounding: rounding,
            visible: visible
        }
    },
    method: handlers.EDIT_CURRENCY,
    tabId: 0
});

export const deleteCurrency = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DELETE_CURRENCY,
        params: {
            id: id
        }
    },
    method: handlers.DELETE_CURRENCY,
    tabId: 0
});
